module.exports = __webpack_public_path__ + "static/media/screenshot-2.8ad390bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-2.png
// module id = 687
// module chunks = 2